/***
 *
 *   LANGUAGE SWITCHER
 *   Compact EN / FR control for the public header. Labels stay in their
 *   native form so a visitor can find their language even when the rest of
 *   the page is in the other one.
 *
 **********/

import { useTranslate } from 'app/translations';
import { cn } from 'utilities/cn';
import Style from './home.tailwind.js';

const OPTIONS = [
    { value: 'en', label: 'EN', name: 'English' },
    { value: 'fr', label: 'FR', name: 'Français' },
];

export function LanguageSwitcher() {
    const { _t, locale, setLocale } = useTranslate();

    return (
        <div
            className={Style.lang}
            role="group"
            title={_t('language.title')}
            aria-label={_t('language.title')}>
            {OPTIONS.map((option) => {
                const active = locale === option.value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        className={cn(Style.langOption, active && Style.langActive)}
                        aria-pressed={active}
                        aria-label={option.name}
                        onClick={() => setLocale(option.value)}>
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
